<template>
	<v-btn
		v-bind="$props"
		:color="outlined ? 'red' : 'white--text red text-none'"
		:outlined="outlined"
		class="px-10 text-none delete-button"
		v-on="$listeners"
	>
		<slot />
	</v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
	name: 'delete-button',
	extends: VBtn,
	props: {
		outlined: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
	// Add hover lift effect to delete buttons
	.v-btn.delete-button {
		transition: all 0.3s ease;

		&:hover:not(:disabled) {
			transform: translateY(-2px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		}
	}
</style>

<!-- Unscoped styles for dark mode overrides -->
<style lang="scss">
	// In dark mode, delete button is always solid danger red
	// This clearly differentiates it from primary (#ed303e) by using a distinct red (#f44336)
	.dark,
	.theme--dark {
		.v-btn.delete-button {
			background-color: var(--global-danger, #f44336) !important;
			border-color: var(--global-danger, #f44336) !important;
			color: #ffffff !important;

			&:hover:not(:disabled) {
				background-color: var(--global-danger-hover, #d32f2f) !important;
				border-color: var(--global-danger-hover, #d32f2f) !important;
			}
		}
	}
</style>
